import HeaderNortification from "@/interface/HeaderNortification";
import { reactive } from 'vue'

export class Nortification {
    private nortifications = [] as HeaderNortification[];
    public get list(){
        return this.nortifications
    }
    public add(nortification:HeaderNortification){
        const idx = this.nortifications.findIndex(n => n.identifer === nortification.identifer)
        if(idx >= 0){
            this.nortifications[idx] = nortification
        }else{
            this.nortifications.push(nortification)
        }
    }
    public clear(identifer:string){
        const idx = this.nortifications.findIndex(n => n.identifer === identifer)
        if(idx >= 0){
            this.nortifications.splice(idx, 1)
        }
    }
}

export const NORTIFICATION_NOT_LOGIN = "not-logined"

//複数のvueで変数の値を共有したいので、事前にnewしたものを渡す。値変更を即HTMLに反映させたいのでリアクティブ化を行っている
export default reactive(new Nortification);
